export default __webpack_public_path__ + "static/media/ageLogo.1806ac31.png";